import {Component, Output, EventEmitter} from '@angular/core';
import {SupplierPidMappingService} from "../../Services/supplierPidMapping.service";
import {LoginService} from "../../Services/login.service";
import {SystemService} from "../../Services/system.service";
import {TranslateService} from "@ngx-translate/core";
import {SignalrService} from "../../Services/signalr.service";
import {Message} from "../../Model/System/Message";
import {filter, firstValueFrom, take, timeout} from "rxjs";

@Component({
  selector: 'np-supplier-pid-mapping-delete-by-list',
  standalone: false,
  templateUrl: './supplier-pid-mapping-delete-by-list.component.component.html',
  styleUrl: './supplier-pid-mapping-delete-by-list.component.component.css'
})
export class SupplierPidMappingDeleteByListComponentComponent {

  @Output() onClosed = new EventEmitter<void>();
  @Output() onDeleteFinished = new EventEmitter<void>();
  kommaTrennzeichen: boolean = true;
  semikolonTrennzeichen: boolean = true;
  inputString: string = "";
  inputList: string[];

  constructor(public supplierPidMappingService: SupplierPidMappingService, public loginService: LoginService, public systemService: SystemService, public translate: TranslateService, private signalrService: SignalrService,) {
  }


  async onValueChangedFormatListIgnoreSpace(event, kommaTrennzeichen: boolean, semikolonTrennzeichen) {
    if (event.event == null)
      return;

    this.inputString = this.formatListIgnoreSpace(event.value, kommaTrennzeichen, semikolonTrennzeichen);

    if (this.inputString.length == 0) {
      return;
    }
  }

  async startDeleteByList() {

    if (this.kommaTrennzeichen == false && this.semikolonTrennzeichen == false) {
      this.systemService.notifyInfo(this.translate.instant('Bitte mindestens ein Trennzeichen verwenden.'));
      return;
    }

    var jobId = await this.supplierPidMappingService.deleteSupplierPidMappingsByList(this.inputString, this.loginService.currentUser.customerId);
    this.systemService.notify(new Message(this.translate.instant('Berechnung wurde als Job gestartet')));

    await this.signalrService.startFinishedJobFeed(jobId.toString());
    try {
      await firstValueFrom(
        this.signalrService.finishedJob$.pipe(
          filter(e => e?.jobId == jobId.toString()),
          take(1),
          timeout(240000) // 4 Minuten
        )
      );
      this.reloadList();
      this.closePopup();
    } finally {
      await this.signalrService.stopFinishedJobFeed(jobId.toString());
    }
  }

  reloadList() {
    this.onDeleteFinished.emit();
  }

  closePopup() {
    this.onClosed.emit();
  }

  protected formatListIgnoreSpace(value, kommaTrennzeichen, semikolonTrennzeichen) {
    var tmp: string = value;
    if (semikolonTrennzeichen)
      tmp = tmp.split(";").join("\n");
    tmp = tmp.split("\r").join("\n");
    if (kommaTrennzeichen)
      tmp = tmp.split(",").join("\n");

    while (tmp.includes("\n\n")) {
      tmp = tmp.replace("\n\n", "\n");
    }

    if (tmp.substr(0, 1) == "\n") {
      tmp = tmp.substr(1);
    }
    if (tmp.substr(-1, 1) == "\n") {
      tmp = tmp.substr(0, tmp.length - 1);
    }
    return tmp;
  }
}
